// extracted by mini-css-extract-plugin
module.exports = {"warning-message-box":"style_warning-message-box__FansM"};